// extracted by mini-css-extract-plugin
export default {"Hamburger":"Hamburger_Hamburger__ulh8p","Close":"Hamburger_Close__7elaa","Light":"Hamburger_Light__JjVsK","Accent":"Hamburger_Accent__p-k+N"};